var _defs, _ellipse, _path, _path2, _path3, _path4, _circle, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path5, _polyline, _path6, _path7, _circle2, _circle3, _rect, _circle4, _circle5, _polygon, _polygon2, _circle6, _path8, _path9, _path10, _circle7, _rect2, _rect3, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLandingModule3 = function SvgLandingModule3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2694.56 2454.99",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f5f9;}.cls-12,.cls-2,.cls-5,.cls-6{fill:none;}.cls-11,.cls-12,.cls-2,.cls-3,.cls-5,.cls-6,.cls-8,.cls-9{stroke:#000;}.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-5,.cls-6,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:31.25px;}.cls-11,.cls-3,.cls-4,.cls-9{fill:#fff;}.cls-3{stroke-width:27.75px;}.cls-5{stroke-width:28.41px;}.cls-6{stroke-width:25.57px;}.cls-7{fill:#ececec;}.cls-10,.cls-13,.cls-8{fill:#35b9cc;}.cls-10,.cls-8,.cls-9{stroke-width:22.72px;}.cls-10{stroke:#1d1d1b;}.cls-11{stroke-width:23.02px;}.cls-12{stroke-width:14.39px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "landing-module3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 800.98,
    cy: 2304.33,
    rx: 483.94,
    ry: 150.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1012.36,977.08c365.7,45.36,472.59-269,503.79-448.67",
    transform: "translate(-75.44 -111.56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1523.15,514.47a911.23,911.23,0,0,0-52.85-85.94",
    transform: "translate(-75.44 -111.56)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1509.14,514.47A911.23,911.23,0,0,1,1562,428.53",
    transform: "translate(-75.44 -111.56)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M634,858.54s-145.6,981.79-144.13,980.58h828.61L1109.17,858.54Z",
    transform: "translate(-75.44 -111.56)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 794.81,
    cy: 418.5,
    r: 404.63
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.09,
    cy: 530.1,
    rx: 85.3,
    ry: 48.74,
    transform: "translate(162.97 1189.7) rotate(-89.36)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.1,
    cy: 529.7,
    rx: 85.3,
    ry: 48.74,
    transform: "translate(341.38 1369.31) rotate(-89.36)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 953.32,
    cy: 614.8,
    rx: 85.3,
    ry: 48.74,
    transform: "translate(252.54 1449.68) rotate(-89.36)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 773.31,
    cy: 614.8,
    rx: 85.3,
    ry: 48.74,
    transform: "matrix(0.01, -1, 1, 0.01, 74.53, 1269.68)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1028.34,1839.12c-22.43,337.11-407,502.78-407,502.78l29.34,115.91",
    transform: "translate(-75.44 -111.56)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "776 1727.56 776 2270.17 678.6 2318.87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1070,1010.54",
    transform: "translate(-75.44 -111.56)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1070,1616.35",
    transform: "translate(-75.44 -111.56)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 589.36,
    cy: 592.99,
    r: 89.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1003.08,
    cy: 595.83,
    r: 89.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 292.69,
    y: 243.07,
    width: 242.58,
    height: 1518.58,
    rx: 33.9,
    transform: "translate(-347.44 50.84) rotate(-16.8)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 851.22,
    cy: 382.1,
    r: 22.54
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 675.33,
    cy: 382.1,
    r: 22.54
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "474.55 1712.26 684.69 1645.16 668.61 1917.44 474.55 1712.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "570.68 1805.21 674.83 1770.31 668.61 1917.44 570.68 1805.21"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1440.71,
    cy: 405.78,
    r: 45.84
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M611.74,953.37c-641.56,257.87-180.78,545-180.78,545",
    transform: "translate(-75.44 -111.56)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2770,1558.24c-19.37-24.7-460.07,50.48-1108.67,68.08C1333.7,838.06,1534.2,403.65,1534.2,403.65H2577.28S2406.53,1112.48,2770,1558.24Z",
    transform: "translate(-75.44 -111.56)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2653,1466.7c-19.37-24.7-403.73,48.79-1052.33,66.38C1273.06,744.83,1485,293.19,1485,293.19l975.31,18.92S2289.54,1020.93,2653,1466.7Z",
    transform: "translate(-75.44 -111.56)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1888.07,
    cy: 319.11,
    r: 43.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1449.95,
    y: 484.08,
    width: 175.22,
    height: 175.22,
    rx: 32.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1478.05,
    y: 752.81,
    width: 175.22,
    height: 175.22,
    rx: 32.49
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1565.66,
    y: 1017.76,
    width: 175.22,
    height: 175.22,
    rx: 32.49
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1793,640.62h457.72c13.89,0,13.91-21.58,0-21.58H1793c-13.88,0-13.91,21.58,0,21.58Z",
    transform: "translate(-75.44 -111.56)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1797.75,732.17h303.54c13.89,0,13.91-21.58,0-21.58H1797.75c-13.88,0-13.91,21.58,0,21.58Z",
    transform: "translate(-75.44 -111.56)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.84,909.45h457.72c13.89,0,13.91-21.58,0-21.58H1820.84c-13.89,0-13.91,21.58,0,21.58Z",
    transform: "translate(-75.44 -111.56)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.71,1001h303.54c13.89,0,13.91-21.58,0-21.58H1822.71c-13.88,0-13.91,21.58,0,21.58Z",
    transform: "translate(-75.44 -111.56)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1916,1180.25h457.72c13.88,0,13.91-21.59,0-21.59H1916c-13.89,0-13.91,21.59,0,21.59Z",
    transform: "translate(-75.44 -111.56)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1917.89,1271.79h303.54c13.89,0,13.91-21.58,0-21.58H1917.89c-13.88,0-13.91,21.58,0,21.58Z",
    transform: "translate(-75.44 -111.56)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1588.67,941.58a152,152,0,0,1,28.41,40.78c4.06,8.38,16.52,9.14,22.6,2.91a800.44,800.44,0,0,0,103-130.31c4.17-6.56,1.37-15.86-5.16-19.69-6.93-4-15.51-1.41-19.68,5.17a762,762,0,0,1-98.5,124.48l22.6,2.92A178.89,178.89,0,0,0,1609,921.23c-5.42-5.57-14.9-5.45-20.34,0a14.6,14.6,0,0,0,0,20.35Z",
    transform: "translate(-75.44 -111.56)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1689.94,1204.19a152.25,152.25,0,0,1,28.41,40.79c4.06,8.38,16.52,9.14,22.6,2.91a800.44,800.44,0,0,0,103-130.31c4.17-6.57,1.38-15.87-5.16-19.69-6.93-4.05-15.51-1.41-19.68,5.16a761.64,761.64,0,0,1-98.5,124.49l22.6,2.91a179,179,0,0,0-32.91-46.6,14.39,14.39,0,0,0-20.35,20.34Z",
    transform: "translate(-75.44 -111.56)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1569.87,679a152,152,0,0,1,28.41,40.78c4.07,8.38,16.52,9.14,22.6,2.91a801,801,0,0,0,103-130.31c4.16-6.56,1.37-15.86-5.17-19.68-6.93-4.06-15.51-1.42-19.68,5.16a761.45,761.45,0,0,1-98.5,124.48l22.6,2.92a178.85,178.85,0,0,0-32.91-46.61c-5.42-5.57-14.9-5.44-20.35,0a14.6,14.6,0,0,0,0,20.35Z",
    transform: "translate(-75.44 -111.56)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLandingModule3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landing-module3.cf63a5ea91d762a269495fd410c377e6.svg";